import { DuplicateReviewPage } from '@/features/DuplicateCheck/DuplicateReviewPage';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const duplicateReviewSearchSchema = z.object({
    projectId: z.number().optional(),
    isAssetView: z.boolean().optional(),
    assetId: z.number().optional(),
});

export const Route = createFileRoute('/documents/duplicate-review/')({
    component: DuplicateReviewPage,
    validateSearch: duplicateReviewSearchSchema,
});
